import { psmGet, psmPatch } from "../api/api";

/**
 * Tenant requests — PSM04.
 *
 * An organization asks to be onboarded from outside the product, with nobody
 * signed in. The request lands in this queue, and all this side of it does is
 * read the queue and move a request's status along; nothing here creates one.
 */
const BASE = "/tenant-requests";

/** The searches are reads; the status flip is the only write. */
const READ = "PSM04S";
const WRITE = "PSM04U";

/**
 * A query string of what was actually filled in.
 *
 * A parameter left blank must not travel: sent empty it would be matched
 * against, and answer nothing.
 */
function query(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const text = String(value).trim();
    if (text !== "") search.set(key, text);
  });
  return search.toString();
}

/** Rows live under data.content when paged, or data itself when not. */
function pageOf(response) {
  const data = response?.data ?? {};
  const rows = Array.isArray(data)
    ? data
    : Array.isArray(data.content)
      ? data.content
      : [];
  return { rows, totalCount: data.totalElements ?? rows.length };
}

/**
 * GET /saas/psm/tenant-requests/search — PSM04S.
 *
 * Every request there is, as one plain array: this endpoint takes no filter
 * and answers no page envelope, so the caller narrows and pages what it gets.
 */
export async function fetchTenantRequests(params = {}) {
  const response = await psmGet(`${BASE}/search?${query(params)}`, READ);
  return pageOf(response);
}

/** GET /saas/psm/tenant-requests/search/status — PSM04S. */
export async function fetchTenantRequestsByStatus(status, params = {}) {
  const response = await psmGet(
    `${BASE}/search/status?${query({ status, ...params })}`,
    READ
  );
  return pageOf(response);
}

/**
 * PATCH /saas/psm/tenant-requests/update/status/{orgId}?status= — PSM04U.
 *
 * The status travels as a query parameter, with onboarding details in the body.
 */
export async function updateTenantRequestStatus(orgId, status, details) {
  const response = await psmPatch(
    `${BASE}/update/status/${encodeURIComponent(orgId)}?${query({ status })}`,
    status === "Onboarded" ? details : undefined,
    WRITE
  );
  return response?.data ?? null;
}

export const tenantRequestService = {
  fetchTenantRequests,
  fetchTenantRequestsByStatus,
  updateTenantRequestStatus,
};

export default tenantRequestService;
